export default "__VITE_ASSET__CCJdCb3F__"